<template>
    <div>
        <sticky-header 
            :user_count="users.length"
            :contacted_count="totalContactedCount"
            :display="showStickyHeader"
            @request="clickRequestNewPatients()"
        />
        <Dialog 
            ref="beforeLeaveDialog" 
            :title="'Usuarios sin Contactar'"
            :text="'Todavía hay usuarios sin contactar. ¿Estás seguro que quieres salir de la página?'"
            :buttons="[
                { text: 'Sí', event: 'leave' },
                { text: 'No', event: 'close'},
            ]"
            @leave="$router.push(leaveRoute)"
            @close="leaveRoute = null"
            @clickOutside="leaveRoute = null"
        />

        <Dialog 
            ref="beforeRequestNewpatientsDialog" 
            :title="'Usuarios sin Contactar'"
            :text="'Todavía hay usuarios sin contactar. ¿Estás seguro que quieres cargar nuevos pacientes?'"
            :buttons="[
                { text: 'Sí', event: 'leave' },
                { text: 'No', event: 'close'},
            ]"
            @leave="requestNewPatients()"
        />

        <Dialog 
            ref="noUsersAvailableDialog" 
            :title="'No hay usuarios disponibles'"
            :text="'Actualmente no hay usuarios disponibles para ser asignados. Por favor, prueba más tarde.'"
            :buttons="[
                { text: 'Cerrar', event: 'close'},
            ]"
        />



        <loading-container v-if="loading" />
        <v-layout fluid wrap id="user-list-page" v-else>
            <v-flex xs12 v-if="users.length > 0">
                <v-layout class="page-header no-background" id="page-header">
                    <v-row align="center" justify="center">
                      <v-flex xs12 md6>
                        <v-layout column align-center>
                        <p id="users_count">
                            Mis usuarios asignados ({{users.length}})
                          <span id="contacted_users_count">
                            {{totalContactedCount}} USUARIOS CONTACTADOS
                          </span>
                        </p>
                      </v-layout>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-layout row align-end>
                          <v-col xs8>
                              <span class="instruction-text">
                                <i>
                                    Se actualizarán todos los datos introducidos y se cargará un nuevo listado de 10 usuarios.
                                </i>
                              </span>
                            </v-col>
                          <v-col xs4>
                              <v-btn class="app-button" id="request-new-users" color="primary"
                              @click="clickRequestNewPatients()">
                              GUARDAR LISTADO</v-btn>
                        </v-col>
                        </v-layout>
                      </v-flex>
                    </v-row>
                </v-layout>
            </v-flex>

            <v-flex v-else xs12 >
                <v-layout class="page-header no-background" >
                    <v-row align="center" justify="center">
                      <v-flex xs8>
                        <v-layout column align-left>
                        <p id="users_count">
                            Mis usuarios asignados ({{users.length}})
                        </p>
                      </v-layout>
                      </v-flex>
                    </v-row>
                </v-layout>
                <v-layout>
                    <v-row align="center" justify="center">
                      <v-flex xs8>
                        <v-layout column align-left>
                            <p id="call-to-action">
                                No tienes ningún usuario asignado. Por favor,
                              <a @click="requestNewPatients()">
                                <b>PIDE NUEVOS USUARIOS &#8594;</b>
                              </a>
                        </p>
                      </v-layout>
                      </v-flex>
                    </v-row>
                </v-layout>
            </v-flex>


            <v-container fill-height>
                <v-layout row wrap  v-for="user in users"  :key="user.id">
                    <v-flex xs12 style="width:2000px">
                        <my-user-card 
                            :user="user"
                            :isExpanded="user.id === expandedId"
                            class="my-user-card" 
                            @expanded="expandedHandler"
                        />
                    </v-flex>
                </v-layout>
            </v-container>
        </v-layout>
    </div>
</template>

<script>
    import MyUserCard from '../components/MyUserCard'
    import Dialog from '../components/Dialog'
    import StickyHeader from '../components/StickyHeader'

    export default {
        name: 'UserList',

        components: {
            MyUserCard,
            Dialog,
            StickyHeader
        },

        mounted () {
            this.$store.dispatch('assigned_users/loadAssignedUser')
        },

        created() {
            document.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            document.removeEventListener('scroll', this.handleScroll);
        },

        data () {
            return {
                expandedId: null,
                absolute:true,
                openModal: true,
                leaveRoute: null,
                showStickyHeader: false,
            }
        },

        computed: {
            userIsAuthenticated() {
                return this.$store.getters['admins/user'] != null && this.$store.getters['admins/user'] != undefined;
            },

            users() {
                return this.$store.getters['assigned_users/assignedUsers']
            },

            noUsersAvailable() {
                return this.$store.getters['assigned_users/noUsersAvailable']
            },

            hasContactedAll () {
                if(this.users.length === 0) return true;
                return this.users.filter(x => x.is_intervened).length === this.users.length;
            },

            loading() {
                return this.$store.getters['assigned_users/loading']
            },

            totalContactedCount() {
                let count = 0;
                for(let i=0; i<this.users.length; i++) {
                    if (this.users[i]["is_intervened"]) {
                        count++;
                    }
                }
                return count;
            }
        },
        methods: {
            clickRequestNewPatients() {
                if (!this.hasContactedAll) {
                    this.$refs.beforeRequestNewpatientsDialog.openModal()
                } else {
                    this.requestNewPatients()
                }
            },

            requestNewPatients() {
                this.$store.dispatch("assigned_users/requestNewPatients");
            },
            expandedHandler(userId) {
                if (this.expandedId === userId) {
                    this.expandedId = null
                } else {
                    this.expandedId = userId;
                    this.$store.dispatch('contact_history/loadContactHistory', userId);
                }
            },
            handleScroll() {
                const pageHeader = document.getElementById('page-header');
                if (!pageHeader) {
                    this.showStickyHeader = false;
                    return
                }

                const distance = pageHeader.offsetTop + pageHeader.offsetHeight;
                const currentScroll = window.pageYOffset;

                if (currentScroll >= distance) this.showStickyHeader = true;
                else this.showStickyHeader = false;

            }
        },

        watch: {
            noUsersAvailable(val) {
                if(val === true) {
                    this.$refs.noUsersAvailableDialog.openModal()
                }
            }
        },

        beforeRouteLeave (to,from,next) {
            if (!this.userIsAuthenticated) {
                next()
            } if (this.leaveRoute || to.name === 'UserProfile' || this.hasContactedAll) {
                next()
            } else {
                this.leaveRoute = to;
                this.$refs.beforeLeaveDialog.openModal()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .page-header {
        min-height: 142px;
        background-color: #e2f3fb;
        width: 100%;

        #request-new-users {
            margin-right: 5rem;
          }

        #users_count {
            font-size: 2.125rem;
        }

        #contacted_users_count {
            font-size: 1.125rem;
            color: #404a57;
            margin-left: 0.5rem;
        }

        .instruction-text {
            color: #246c8e;
            font-size: 0.9rem;
        }
    }

    .no-background {
        background-color: transparent;
    }

    .my-user-card {
        margin-bottom: 1rem;
    }

    #call-to-action {
        color: #222c38;
        font-size: 1.5rem;
    }
</style>